export default __webpack_public_path__ + "static/media/linkedin.03593a9b.svg";